import { useCallback } from 'react'
import axios from 'axios'
import { notification } from 'antd'
import { fetchTaskById } from '@/entities/task/api/tasksApi'
import { useSystemStore } from '@/app/store/systemStore'
import { extractAccountId } from '../lib/extractAccountId'
import { downloadCredentialsAsXLS } from '../lib/downloadCredentialsAsXLS'
import { fetchCredentials } from '../api/credentialsApi'

export const useDownloadCredentials = () => {
  const { selectedSystem } = useSystemStore()

  const downloadCredentials = useCallback(
    async (taskId: string) => {
      try {
        const taskData = await fetchTaskById(taskId)
        const accountId = extractAccountId(taskData)
        const cryptoKey = taskData.cryptoKey || ''

        if (!accountId) {
          console.error('❌ accountId не найден в данных задачи')
          notification.warning({
            message: 'Предупреждение',
            description: 'accountId не найден в данных задачи',
          })
          return
        }

        const credentialsData = await fetchCredentials(
          selectedSystem,
          accountId,
          cryptoKey
        )

        if (Array.isArray(credentialsData)) {
          downloadCredentialsAsXLS(credentialsData, accountId)
        } else {
          console.warn('⚠️ Данные credentials не являются массивом')
          notification.warning({
            message: 'Предупреждение',
            description: 'Не удалось получить данные для экспорта',
          })
        }
      } catch (error) {
        console.error('❌ Ошибка при загрузке credentials:', error)

        if (axios.isAxiosError(error)) {
          notification.error({
            message: 'Ошибка загрузки',
            description: `Не удалось загрузить credentials: ${error.response?.status} ${error.response?.statusText}`,
          })
        } else {
          notification.error({
            message: 'Ошибка загрузки',
            description: 'Неизвестная ошибка при загрузке credentials',
          })
        }
      }
    },
    [selectedSystem]
  )

  return { downloadCredentials }
}
